module.exports = __webpack_public_path__ + "img/vorota.93a95ca5.svg";